export const setLoadingData = (loading: boolean) => ({
    type: 'SET_LOADING_DATA',
    payload: loading,
})